import React from "react";
import { Redirect, Route, withRouter } from "react-router-dom";
import Header from "../components/admin/Header";
import PropTypes from "prop-types";
import { useQuery, useQueryClient } from "react-query";
import { loadCurrentUser } from "../queries/session";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
import toast from "react-hot-toast";
import useSession from "../components/common/useSession";

const AdminRoute = ({ cableApp, component: Component, ...rest }) => {
  const queryClient = useQueryClient();
  const [jwt, isAuthenticated] = useSession();
  const { isLoading, data: currentUser } = useQuery(
    "currentUser",
    async () =>
      await loadCurrentUser().then((user) => {
        cableApp.cable["_url"] = `${cableApp.cable["url"]}?jwt=${jwt}`;
        return user;
      }),
    {
      enabled: isAuthenticated(),
    }
  );

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() && !isLoading ? (
          <>
            <Header queryClient={queryClient} currentUser={currentUser} />
            <div className="content">
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <Component
                  {...props}
                  queryClient={queryClient}
                  cableApp={cableApp}
                  currentUser={currentUser}
                  toast={toast}
                />
              </ErrorBoundary>
            </div>
          </>
        ) : !isAuthenticated() && !isLoading ? (
          <Redirect to="/login" />
        ) : null
      }
    />
  );
};

AdminRoute.propTypes = {
  cableApp: PropTypes.object.isRequired,
};

export default withRouter(AdminRoute);
